import React from "react";
import * as appRouting from "appRouting";
import ForgotPasswordResetForm from "user/authentication/ui/forms/ForgotPasswordResetForm";
// Bootstrap
import { Panel } from "react-bootstrap";
import AuthContainer from "user/authentication/ui/views/components/AuthContainer";
import AuthInfo from "user/authentication/ui/views/components/AuthInfo";
import AuthAlreadyHasPassword from "user/authentication/ui/views/components/AuthAlreadyHasPassword";
import AuthLinkButton from "user/authentication/ui/views/components/AuthLinkButton";
//-- Props -------------------------------------------------------------------------------------------------------------------------------
export class ForgotPasswordResetView extends React.Component {
    render() {
        return (React.createElement(AuthContainer, { isLarge: true },
            React.createElement(Panel, null,
                React.createElement(Panel.Heading, null,
                    React.createElement(Panel.Title, { componentClass: "h4" }, "Reset Password")),
                React.createElement(Panel.Body, null,
                    React.createElement(AuthInfo, null, "After entering your one-time pin code (OTP) that has been sent to your mobile phone, enter and confirm a new password to use Insights."),
                    React.createElement(ForgotPasswordResetForm, null),
                    React.createElement(AuthLinkButton, { url: appRouting.forgotPasswordPath(), text: "Resend OTP" }),
                    React.createElement(AuthAlreadyHasPassword, null)))));
    }
}
